interface ScoreBreakdownItem {
  dimension: string
  score: number
}

interface MobileScoreCardProps {
  score: number
  breakdown: ScoreBreakdownItem[]
  onImprove: () => void
  onMatchJobs: () => void
}

function ScoreRing({ score }: { score: number }) {
  const radius = 36
  const strokeWidth = 6
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (score / 100) * circumference

  return (
    <div className="relative inline-flex items-center justify-center w-16 h-16 sm:w-[88px] sm:h-[88px] shrink-0">
      <svg
        viewBox="0 0 88 88"
        className="-rotate-90 w-full h-full"
        aria-labelledby="score-ring-title"
      >
        <title id="score-ring-title">Resume score {score} out of 100</title>
        <circle
          cx={44}
          cy={44}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          className="text-muted/20"
        />
        <circle
          cx={44}
          cy={44}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="text-brand"
        />
      </svg>
      <span className="absolute text-base sm:text-xl font-semibold">{score}</span>
    </div>
  )
}

function ScoreBar({ label, value }: { label: string; value: number }) {
  return (
    <div className="space-y-1">
      <div className="flex justify-between text-xs">
        <span className="text-muted-foreground">{label}</span>
        <span className="font-medium">{value}</span>
      </div>
      <div className="h-1.5 rounded-full bg-muted/20">
        <div
          className="h-full rounded-full bg-brand transition-all"
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  )
}

export function MobileScoreCard({
  score,
  breakdown,
  onImprove,
  onMatchJobs,
}: MobileScoreCardProps) {
  return (
    <div className="rounded-lg border bg-card p-4 my-2">
      <div className="flex items-center gap-3 sm:gap-4">
        <ScoreRing score={score} />
        <div className="flex-1 min-w-0 space-y-2">
          {breakdown.map((item) => (
            <ScoreBar key={item.dimension} label={item.dimension} value={item.score} />
          ))}
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        <button
          type="button"
          onClick={onImprove}
          className="flex-1 text-xs sm:text-sm font-medium py-2 px-2 rounded-lg border border-brand text-brand hover:bg-brand hover:text-brand-foreground transition-colors truncate"
        >
          Improve with Coach
        </button>
        <button
          type="button"
          onClick={onMatchJobs}
          className="flex-1 text-xs sm:text-sm font-medium py-2 px-2 rounded-lg bg-brand text-brand-foreground hover:bg-brand-hover transition-colors truncate"
        >
          Match with Jobs
        </button>
      </div>
    </div>
  )
}
